import { ReactNode, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import StickyButtons from "../ui/StickyButtons";
import LeadPopup from "../lead/LeadPopup";
import { injectIntegrationScripts, trackPageView } from "@/lib/scriptSanitizer";
import { useTheme } from "@/contexts/ThemeContext";
import { useSEO } from "@/hooks/useSEO";

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const { isEditorPreview } = useTheme();
  const location = useLocation();

  // Apply SEO meta tags from admin settings
  useSEO();

  // Inject scripts on mount & listen for re-injection events (after admin saves)
  useEffect(() => {
    if (!isEditorPreview) {
      injectIntegrationScripts();

      const handleReload = () => injectIntegrationScripts(true);
      window.addEventListener('integrations-updated', handleReload);
      return () => window.removeEventListener('integrations-updated', handleReload);
    }
  }, [isEditorPreview]);

  // Track SPA page views on route change
  useEffect(() => {
    if (!isEditorPreview) {
      trackPageView(location.pathname + location.search);
    }
  }, [location.pathname, location.search, isEditorPreview]);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      {!isEditorPreview && <StickyButtons />}
      {!isEditorPreview && <LeadPopup />}
    </div>
  );
}
